import gql from 'graphql-tag';

const SAVE_TABLE_PREFRENCES = gql`
  mutation Mutation(
    $tableRows: [String]
    $stages: [String]
    $deviceType: [String]
    $firmwareVersion: [String]
    $OTAFirmwareVersion: [String]
    $hardwareVersion: [Int]
    $tags: [String]
    $softwareVersion: [Int]
    $batch: [String]
    $vendor: [String]
    $networkProvider: [String]
    $arambhDevice: Boolean
    $OTACompatible: Boolean
  ) {
    saveUserPrefrences(
      tableRows: $tableRows
      stages: $stages
      deviceType: $deviceType
      firmwareVersion: $firmwareVersion
      OTAFirmwareVersion: $OTAFirmwareVersion
      tags: $tags
      hardwareVersion: $hardwareVersion
      softwareVersion: $softwareVersion
      batch: $batch
      vendor: $vendor
      networkProvider: $networkProvider
      arambhDevice: $arambhDevice
      OTACompatible: $OTACompatible
    ) {
      code
    }
  }
`;

export default SAVE_TABLE_PREFRENCES;
